import { render } from "./authorization.vue?vue&type=template&id=42a60ec4&scoped=true"
import script from "./authorization.vue?vue&type=script&lang=js"
export * from "./authorization.vue?vue&type=script&lang=js"

import "./authorization.vue?vue&type=style&index=0&id=42a60ec4&lang=less&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a60ec4"]])

export default __exports__